import styled from "@emotion/styled";

export const NewsTickerContainer = styled.div`
  block-size: auto;
`;
